import { render, staticRenderFns } from "./DiyNav.vue?vue&type=template&id=33867986&scoped=true&"
import script from "./DiyNav.vue?vue&type=script&lang=js&"
export * from "./DiyNav.vue?vue&type=script&lang=js&"
import style0 from "./DiyNav.vue?vue&type=style&index=0&id=33867986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33867986",
  null
  
)

export default component.exports